import React from "react";
import SEO from "../components/SEO";
import legalData from "../data/legal.json";

export default function Disclaimer() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={legalData.disclaimer?.title}
        description={legalData.disclaimer?.description}
        ogType="website"
      />
      <section className="section-padding mx-auto w-full max-w-4xl">
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          Disclaimer
        </p>
        <h1 className="page-title mt-3">
          Manage Your Vastu Disclaimer
        </h1>
        <div className="card mt-6 space-y-4 p-6 text-sm text-slate-600">
          <p>
            This is a placeholder disclaimer for Manage Your Vastu. Replace with
            legal content before launch.
          </p>
          <p>
            Vastu guidance is informational and should be reviewed with a
            qualified professional.
          </p>
        </div>
      </section>
    </div>
  );
}
